export const BLOG_HOME_PAGE = '/blog';
export const HOME_PAGE_NAME = 'holding';
